import { isEqual } from 'lodash'
import { dateFormatter } from '@/helpers/dateFormatter'
import { IBaseChanges } from './model'

export interface IContextPartATE {
  is_active: boolean;
  long_name: string;
  municipality_code: string;
  municipality_name: string;
  region_code: string;
  region_name: string;
  school_code: string;
  school_name: string;
}

export interface IContextATE {
  from: IContextPartATE;
  to: IContextPartATE;
}

export interface IChangesATE extends IBaseChanges {
  context: IContextATE;
}

/**
 * Получить ключи, в которых есть изменения для АТЕ
 * @param {IContextATE} ctx Контекст АТЕ
 * @returns {Array<keyof IContextPartATE>} ключи
 */
export const getDifferenceContextATE = (ctx: IContextATE): Array<keyof IContextPartATE> => {
  const res: Array<keyof IContextPartATE> = [];

  (Object.keys(ctx.from) as Array<keyof IContextPartATE>).forEach((key) => {
    if (!isEqual(ctx.from[key], ctx.to[key])) {
      res.push(key)
    }
  })

  return res
}

export const getContextKeyRepr = (k: keyof IContextPartATE): string => {
  switch (k) {
    case 'is_active':
      return 'Активен'
    case 'long_name':
      return 'Полное наименование'
    case 'municipality_code':
      return 'Код муниципалитета'
    case 'municipality_name':
      return 'Наименование муниципалитета'
    case 'region_code':
      return 'Код региона'
    case 'region_name':
      return 'Наименование региона'
    case 'school_code':
      return 'Код ОО'
    case 'school_name':
      return 'Наименование ОО'
    default: return ''
  }
}

export const ATE_HEADERS = [
  {
    text: 'Дата изменения',
    value: 'created_at',
    sortable: false,
    field: (value: string | null | undefined) => (
      value && dateFormatter(value)
    ),
  },
  {
    text: 'Элемент',
    value: 'ate_element',
    sortable: false,
    getValue: (v: IChangesATE) => {
      const diff = getDifferenceContextATE(v.context)

      return diff.map((key) => `<div>${getContextKeyRepr(key)}</div>`).join('') || '-'
    },
  },
  {
    text: 'Было',
    value: 'ate_from',
    sortable: false,
    getValue: (v: IChangesATE) => {
      const diff = getDifferenceContextATE(v.context)

      return diff.map((key) => `<div>${v.context.from[key]}</div>`).join('') || '-'
    },
  },
  {
    text: 'Стало',
    value: 'ate_to',
    sortable: false,
    getValue: (v: IChangesATE) => {
      const diff = getDifferenceContextATE(v.context)

      return diff.map((key) => `<div>${v.context.to[key]}</div>`).join('') || '-'
    },
  },
]
